import { CalendarSchedulesModel, ClassGroupModel, ClassModelSchedules, StudentGroupModel } from "@/models";
import { ResourceModel } from "@/models/resource.model";
import { UserModel } from "@/models/user.model";
import { ScheduleType } from "@/utils/utils";
import moment from "moment";
import { MutationTree } from "vuex";
import { CalendarFilter, TeacherState } from "./state";
import { FetchOngoingSessionModel } from "@/services";
import { defineVuexName, MODULES } from "@/store/utils";

const mutations: MutationTree<TeacherState> = {
  //setSchools
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_SCHOOLS)](state: TeacherState, payload: Array<ResourceModel>) {
    state.schools = payload;
    state.currentSchoolId = payload[0].id;
  },
  //setClassesSchedules
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_CLASSES_SCHEDULES)](state: TeacherState, payload: Array<ClassModelSchedules>) {
    state.classesSchedules = payload;
  },
  //setClassesSchedulesAllSchool
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_CLASSES_SCHEDULES_ALL_SCHOOL)](state: TeacherState, payload: Array<ClassModelSchedules>) {
    state.classesSchedulesAllSchool = payload;
  },
  //clearCalendarSchedule
  [defineVuexName(MODULES.TEACHER.COMMITS.CLEAR_CALENDAR_SCHEDULE)](state: TeacherState) {
    state.calendarSchedules = [];
  },
  //clearAllClassesSchedulesAllSchool
  [defineVuexName(MODULES.TEACHER.COMMITS.CLEAR_ALL_CLASSES_SCHEDULES_ALL_SCHOOL)](state: TeacherState) {
    state.classesSchedulesAllSchool = [];
  },
  //setCalendarSchedule
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_CALENDAR_SCHEDULES)](state: TeacherState, payload: Array<CalendarSchedulesModel>) {
    if (payload) {
      state.calendarSchedules = payload.map((calendarSchedule) => {
        calendarSchedule.schedules.map((schedule) => {
          if (schedule.customizedScheduleId == null) {
            schedule.customizedScheduleId = "0000-" + Math.random().toString(36).substr(2, 9);
          }
          return schedule;
        });
        return calendarSchedule;
      });
    }
  },
  //setInfo
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_INFO)](state: TeacherState, payload: UserModel) {
    state.info = payload;
  },
  //setAcceptPolicy
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_ACCEPT_POLICY)](state: TeacherState, payload: boolean) {
    state.acceptPolicy = payload;
  },
  //updateCalendarSchedule
  [defineVuexName(MODULES.TEACHER.COMMITS.UPDATE_CALENDAR_SCHEDULE)](state: TeacherState, payload: any) {
    const dayExist = state.calendarSchedules.filter((calendarSchedule) => {
      return calendarSchedule.day == payload.day;
    });
    switch (payload.data.type) {
      case "Create":
        if (dayExist.length > 0) {
          state.calendarSchedules.map((dayCalendar) => {
            if (dayCalendar.day == payload.day) {
              dayCalendar.schedules.push({
                classId: payload.data.schoolClassId,
                className: payload.className,
                groupId: payload.data.groupId,
                groupName: payload.groupName,
                end: moment(payload.data.end).format("HH:mm:ss"),
                start: moment(payload.data.start).format("HH:mm:ss"),
                customizedScheduleId: payload.id,
                customizedScheduleType: ScheduleType.Create,
                timeId: payload.data.timeId,
                isHistory: false,
              });
            }
            return dayCalendar;
          });
        } else {
          state.calendarSchedules.push({
            day: payload.day,
            schedules: [
              {
                classId: payload.data.schoolClassId,
                className: payload.className,
                groupId: payload.data.groupId,
                groupName: payload.groupName,
                end: moment(payload.data.end).format("HH:mm:ss"),
                start: moment(payload.data.start).format("HH:mm:ss"),
                customizedScheduleId: payload.id,
                customizedScheduleType: ScheduleType.Create,
                timeId: payload.data.timeId,
                isHistory: false,
              },
            ],
          });
          state.calendarSchedules.sort((a, b) => moment(a.day).valueOf() - moment(b.day).valueOf());
        }
        break;
      case "Skip": {
        const dayCalendar = state.calendarSchedules.find((item) => item.day === payload.day);
        if (dayCalendar) {
          const schedule = dayCalendar.schedules.find((s) => s.customizedScheduleId === payload.customId);
          if (schedule) {
            schedule.customizedScheduleType = ScheduleType.Cancelled;
            schedule.customizedScheduleId = payload.scheduleId;
          }
        }
        break;
      }
      case "Delete":
        if (!payload.data.customizedScheduleType || payload.data.customizedScheduleType === ScheduleType.Create) {
          state.calendarSchedules.map((dayCalendar) => {
            if (dayCalendar.day == payload.day) {
              dayCalendar.schedules = dayCalendar.schedules.filter((schedule) => {
                return schedule.customizedScheduleId != payload.data.scheduleId;
              });
            }
            return dayCalendar;
          });
        } else {
          if (payload.data.customizedScheduleType === ScheduleType.Cancelled) {
            const dayCalendar = state.calendarSchedules.find((item) => item.day === payload.day);
            if (dayCalendar) {
              const schedule = dayCalendar.schedules.find((s) => s.customizedScheduleId === payload.data.scheduleId);
              if (schedule) {
                schedule.customizedScheduleId = "0000-" + Math.random().toString(36).substr(2, 9);
                schedule.customizedScheduleType = null;
              }
            }
          }
        }

        break;
      case "Update":
        state.calendarSchedules.map((dayCalendar) => {
          if (dayCalendar.day == payload.day) {
            dayCalendar.schedules = dayCalendar.schedules.map((schedule) => {
              if (schedule.customizedScheduleId != payload.data.customizedScheduleId) return schedule;
              schedule.groupName = payload.groupName;
              schedule.groupId = payload.data.groupId;
              schedule.start = moment(payload.data.start).format("HH:mm:ss");
              schedule.end = moment(payload.data.end).format("HH:mm:ss");
              return schedule;
            });
          }
          return dayCalendar;
        });
        break;
    }
  },
  //setCurrentSchool
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_CURRENT_SCHOOL)](state: TeacherState, payload: string) {
    state.currentSchoolId = payload;
  },
  //setClassSetUpStudents
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_CLASS_SET_UP_STUDENTS)](state: TeacherState, payload: Array<StudentGroupModel>) {
    state.classSetUpStudents = payload;
  },
  //setClassGroup
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_CLASS_GROUP)](state: TeacherState, payload: Array<ClassGroupModel>) {
    state.classGroup = payload;
  },
  //setCalendarFilter
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_CALENDAR_FILTER)](state: TeacherState, payload: CalendarFilter) {
    state.calendarFilter = payload;
  },
  //setIsHelper
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_IS_HELPER)](state, payload: boolean) {
    state.isHelper = payload;
  },
  //setIgnoreHelperRequestJoinClass
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_IGNORE_HELPER_REQUEST_JOIN_CLASS)](state, payload: boolean) {
    state.ignoreHelperRequestJoinClass = payload;
  },
  //setIsHelperTakingOver
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_IS_HELPER_TAKING_OVER)](state, payload: boolean) {
    state.isHelperTakingOver = payload;
  },
  [defineVuexName(MODULES.TEACHER.COMMITS.SET_ONGOING_SESSION)](state, payload: FetchOngoingSessionModel | null) {
    state.ongoingSession = payload;
  },
};

export default mutations;
